import { Components } from "@mui/material/styles";

const MuiSkeleton: Components["MuiSkeleton"] = {
    styleOverrides: {
        root: {
            backgroundColor: "var(--mui-palette-gray-300)",
        },
        rectangular: {
            borderRadius: "2px",
        },
    },
};

export { MuiSkeleton };
